import BarleyProduct from 'models/BarleyProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BarleyPackage from './BarleyPackage'

const productOptions = {
  packagingInfo: <BarleyPackage />,
  productTitle: 'Whole Grain Barley (No Pearl)',
  model: BarleyProduct,
  validCategories: ['16'],
  validSubCategories: ['006'],
}

const Barley = () => <ProductForm product={productOptions} />

export default Barley

export const getBarleyPackage = newProduct => {
  const newBarleyPackage = {
    UPC: newProduct.UPC,
    WholeGrainType: 'Barley',
    BarleyVerification: newProduct.BarleyVerification,
    GrainSize: newProduct.GrainSize,
    Organic: newProduct.Organic,
  }
  return newBarleyPackage
}

export const updateBarleyPackage = newProduct => {
  const newBarleyPackage = {
    UPC: newProduct.UPC,
    WholeGrainType: 'Barley',
    BarleyVerification: newProduct.BarleyVerification,
    GrainSize: newProduct.GrainSize,
    Organic: newProduct.Organic,
  }
  return newBarleyPackage
}
